import s from 'pages/Registration/Intro/Point.module.scss';

type PointProps = {
  number: number;
  description: string;
  dataTest?: string;
};

function Point({ number, description, dataTest = 'point' }: PointProps) {
  return (
    <div className={s.row} data-test={`${dataTest}-layout`}>
      <div className={s.point} data-test={`${dataTest}-number`}>
        {number}
      </div>
      <div className={s.decsription} data-test={`${dataTest}-desc`}>
        {description}
      </div>
    </div>
  );
}

export default Point;
